<template>
    <div>
        <div id="form-step-3">
            <fieldset>
                <div class="row">
                    <legend>Terms of Service</legend>
                </div>
                <div class="row">
                    <div class="columns small-12 lp">
                        <div v-if="!isNPLEorSalesRep" class="terms" v-html="termsContent"></div> <br>
                        <div v-if="isRayban2">
                            <label for="termsaccept1" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item1" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept1" name="AcceptTerm1" v-validate="'required'" type="checkbox" class="termscheck"> 
                                In case of a user-supplied frame to come
                                <ul style="margin-left: 50px">
                                    <li>I understand I have 30 days after redemption to send in frames before the evaluation product will be canceled, as stipulated in the terms of service. </li>
                                    <li>I understand that Essilor is not responsible for lost, postage-due, misdirected, or damaged frames, as stipulated in the terms of service.</li>
                                </ul>
                            </label>
                            <label for="termsaccept2" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item2" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept2" name="AcceptTerm2" v-validate="'required'" type="checkbox" class="termscheck"> 
                                I understand the evaluation product order will be returned within 2-4 weeks from receipt of the order (4-6 weeks after receipt of frames for user-supplied frames) , as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept3" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item3" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept3" name="AcceptTerm3" v-validate="'required'" type="checkbox" class="termscheck"> 
                                A replacement on evaluation product orders are only available within 30 days of shipping from the lab as stipulated in the terms of service
                            </label>
                            <label for="termsaccept4" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item4" v-on:change="changeAcceptedTerms('rb2')" id="termsaccept4" name="AcceptTerm4" v-validate="'required'" type="checkbox" class="termscheck"> 
                                I understand and agree to all terms of service. 
                            </label>
                        </div>
                        <div v-if="isNPLEorSalesRep">
                            <label for="termsacceptlabel" class="termslabel lp"> 
                                By accepting these
                                <span v-if="isCrizalNaturalLook">Crizal Natural Look</span>
                                <span v-else-if="isVxShift">Varilux<sup>&reg;</sup> Shift<sup>&trade;</sup></span>
                                <span v-else>Transitions<sup>&reg;</sup> Gen S<sup>&trade;</sup></span>
                                lenses, I agree that:
                            </label>
                            <label for="termsaccept1" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item1" v-on:change="changeAcceptedTerms('tgens')" id="termsaccept1" name="AcceptTerm1" v-validate="'required'" type="checkbox" class="termscheck"> 
                                I will not sell these lenses to any person or entity;
                            </label>
                            <label for="termsaccept2" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item2" v-on:change="changeAcceptedTerms('tgens')" id="termsaccept2" name="AcceptTerm2" v-validate="'required'" type="checkbox" class="termscheck"> 
                                I will not seek reimbursement for these lenses from any federal, state or commercial health care program, plan, third party payer;                            </label>
                            <label for="termsaccept3" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item3" v-on:change="changeAcceptedTerms('tgens')" id="termsaccept3" name="AcceptTerm3" v-validate="'required'" type="checkbox" class="termscheck"> 
                                I will not offer or provide these lenses to any a person who is enrolled or eligible to enroll in a federal health care program (e.g., Medicare, Medicaid, TRICARE).
                            </label>
                        </div>
                        <div v-else>
                            <label for="termsaccept5" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item5" v-on:change="changeAcceptedTerms()" id="termsaccept5" name="AcceptTerm5" v-validate="'required'" type="checkbox" class="termscheck"> <strong> I acknowledge and affirm, I am presently in a patient-facing role within the eyecare industry, which may include positions such as an Optician, Optometrist, Ophthalmologist, Optical Technician, or Eyewear Consultant. </strong>
                            </label>
                            <label for="termsaccept7" class="termslabel lp" v-if="isVariluxXr"> 
                                <input v-model="acceptedTerms.item7" v-on:change="changeAcceptedTerms()" id="termsaccept7" name="AcceptTerm7" v-validate="'required'" type="checkbox" class="termscheck"> <strong> I certify that I have not tried Varilux<sup>&reg;</sup> XR series<sup>&trade;</sup> evaluation product before. If I order multiple Varilux<sup>&reg;</sup> XR series<sup>&trade;</sup> Evaluation products, Essilor has rights to bill my practice with full wholesale cost of evaluation product. </strong>
                            </label>
                            <label for="termsaccept8" class="termslabel lp" v-if="isLegacy"> 
                                <input v-model="acceptedTerms.item8" v-on:change="changeAcceptedTerms()" id="termsaccept8" name="AcceptTerm8" v-validate="'required'" type="checkbox" class="termscheck"> <strong> I certify that I have not evaluated this product before. If I order Evaluation Product that doesn't not meet terms and conditions, Essilor has right to bill my practice with full wholesale price</strong>
                            </label>
                            <label for="termsaccept1" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item1" v-on:change="changeAcceptedTerms()" id="termsaccept1" name="AcceptTerm1" v-validate="'required'" type="checkbox" class="termscheck"> In case of a user supplied frame to come, I understand that Essilor is not responsible for lost, postage-due, misdirected, or damaged frames, as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept2" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item2" v-on:change="changeAcceptedTerms()" id="termsaccept2" name="AcceptTerm2" v-validate="'required'" type="checkbox" class="termscheck"> I understand the evaluation product order will be returned within 4-6 weeks from receipt of the frames, as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept3" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item3" v-on:change="changeAcceptedTerms()" id="termsaccept3" name="AcceptTerm3" v-validate="'required'" type="checkbox" class="termscheck"> In case of a user supplied frame to come, I understand I have 60 days after redemption to send in frames before the evaluation product will be canceled, as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept4" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item4" v-on:change="changeAcceptedTerms()" id="termsaccept4" name="AcceptTerm4" v-validate="'required'" type="checkbox" class="termscheck"> A replacement on evaluation product orders are only available within 30 days of shipping from the lab as stipulated in the terms of service.
                            </label>
                            <label for="termsaccept6" class="termslabel lp"> 
                                <input v-model="acceptedTerms.item6" v-on:change="changeAcceptedTerms()" id="termsaccept6" name="AcceptTerm6" v-validate="'required'" type="checkbox" class="termscheck"> I understand and agree to all terms of service.
                            </label>
                        </div>
                    </div>
                    <div :class="{'error': !acceptedAllTerms }">
                        <p class="error" v-if="!acceptedAllTerms">You must accept the terms of service</p>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>
<script>
export default {
    props: ['sampleobject', 'terms-content'],
    inject: ['$validator'],
    data() {
        return {
            acceptedTerms: {
                item1: false,
                item2: false,
                item3: false,
                item4: false,
                item5: false,
                item6: false,
                item7: false,
                item8: false,
            },
            acceptedAllTerms: false,
            isRayban2: false,
            isVariluxXr: false,
            isLegacy: false,
            isNPLEorSalesRep: false,
            isTgens: false,
            isVxShift: false,
            isCrizalNaturalLook: false,
        }
    },
    created() {
        var page = this.$route.name; // order_review
        var preCouponText = this.$route.params.couponCode.toString().split('-')[0]
        this.isRayban2 = preCouponText.includes("RBAN2") && page === 'order_review'
        this.isCrizalNaturalLook = preCouponText.includes("CNLIN")
        this.isTgens = preCouponText.includes("TGSIX")
        this.isVxShift = preCouponText.includes("VXS1A")
        this.isNPLEorSalesRep = this.isTgens || this.isCrizalNaturalLook && page === 'order_review'
        this.isVariluxXr = preCouponText.includes("VXXR")
        this.isLegacy = preCouponText.includes("L230")
    },
    methods: {
        changeAcceptedTerms(program = '') {
            this.acceptedAllTerms = this.acceptedTerms.item1 && this.acceptedTerms.item2 && this.acceptedTerms.item3 && this.acceptedTerms.item4 && this.acceptedTerms.item5 && this.acceptedTerms.item6;
            // Rayban2 only
            if (program === 'rb2')
                this.acceptedAllTerms = this.acceptedTerms.item1 && this.acceptedTerms.item2 && this.acceptedTerms.item3 && this.acceptedTerms.item4;
            // Varilux XRs
            else if (this.isVariluxXr)
                this.acceptedAllTerms = this.acceptedAllTerms && this.acceptedTerms.item7
            // Legacy
            else if (this.isLegacy)
                this.acceptedAllTerms = this.acceptedAllTerms && this.acceptedTerms.item8
            else if (program === 'tgens')
                this.acceptedAllTerms = this.acceptedTerms.item1 && this.acceptedTerms.item2 && this.acceptedTerms.item3;     
            this.sampleobject.acceptedTerms = this.acceptedAllTerms;
        }
    }
}
</script>

<style>
.terms {
    height: 200px;
    overflow-y: scroll;
    border: 1px solid black;
    margin: auto;
    padding: 32px;
}

.terms p, .terms ul li {
    font-size:smaller;
}

.termslabel {
    font-size: 12pt;
}

.termscheck {
    font-size: 12pt;
}
</style>
